import React, { useState, useEffect, useContext } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import { ChevronDown, ChevronUp } from "react-feather";
import AccordionContext from "react-bootstrap/AccordionContext";
import { BlurSpinner } from "../../BlurSpinner";
import Component from "../component";
import "../courseStyles.scss";
import { IndicePreview, Title, TitlePreview } from "./styles";

function ContextAwareToggle({ eventKey, callback, order, title, components }) {
  const [isOpen, setIsOpen] = useState(true);
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

  const isCurrentEventKey = activeEventKey === eventKey;

  useEffect(() => {
    setIsOpen(isCurrentEventKey);
  }, [isCurrentEventKey]);

  return (
    <button type="button" className="custom-button_preview" onClick={decoratedOnClick}>
      <IndicePreview>{order}</IndicePreview>
      {title ? (
        <TitlePreview style={{ border: components === 0 ? "1px solid red" : "none" }}>
          {title}
          <div className="d-flex align-items-center">
            {components === 0 && <p style={{ color: "red", margin: "0 5px 0 0" }}> No hay componentes</p>}
            {isOpen ? <ChevronUp size="22" /> : <ChevronDown size="22" />}
          </div>
        </TitlePreview>
      ) : (
        <TitlePreview>Valoración</TitlePreview>
      )}
    </button>
  );
}

export default function CourseUnitsTree({ course }) {
  const [units, setUnits] = useState([]);

  useEffect(() => {
    if (course && course.labUnit) {
      setUnits(course.labUnit);
    }
  }, [course]);

  return (
    <>
      <BlurSpinner>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card" style={{ boxShadow: "none" }}>
                <div className="card-body p-5">
                  <Title>Unidades</Title>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="conteiner-fluid w-100">
                        <Accordion defaultActiveKey="0">
                          {units &&
                            units
                              .sort((a, b) => a.sort_order - b.sort_order)
                              .map((unit, indexUnit) => (
                                <>
                                  <Card className="mb-1" style={{ boxShadow: "none" }} key={unit.id + unit.sort_order}>
                                    <Card.Header className="card-header_preview">
                                      <ContextAwareToggle
                                        className="toggle_preview"
                                        eventKey={unit.sort_order === 1 ? "0" : unit.id.toString()}
                                        order={indexUnit + 1}
                                        title={unit.title}
                                        components={unit.labComponent && unit.labComponent.length}
                                      />
                                    </Card.Header>
                                    <Accordion.Collapse eventKey={unit.sort_order === 1 ? "0" : unit.id.toString()} style={{ background: "none" }} className="mt-1">
                                      <div className="d-flex justify-content-end">
                                        <div className="accordion-body_preview">
                                          {unit &&
                                            unit.labComponent &&
                                            unit.labComponent.length > 0 &&
                                            unit.labComponent
                                              .sort((a, b) => a.sort_order - b.sort_order)
                                              .map((component, index) => (
                                                <>
                                                  <Component key={component.id} index={index} component={component} title={component.title} preview />
                                                </>
                                              ))}
                                        </div>
                                      </div>
                                    </Accordion.Collapse>
                                  </Card>
                                </>
                              ))}
                          <Card className="mb-2">
                            <Card.Header className="card-header_preview">
                              <ContextAwareToggle className="toggle_preview" order={units.length + 1} />
                            </Card.Header>
                          </Card>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
}
